// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NativeTransfer } from './NativeTransfer';
import {
    NativeTransferFromJSON,
    NativeTransferFromJSONTyped,
    NativeTransferToJSON,
} from './NativeTransfer';
import type { ProgramInfo } from './ProgramInfo';
import {
    ProgramInfoFromJSON,
    ProgramInfoFromJSONTyped,
    ProgramInfoToJSON,
} from './ProgramInfo';
import type { TokenSwapNativeInput } from './TokenSwapNativeInput';
import {
    TokenSwapNativeInputFromJSON,
    TokenSwapNativeInputFromJSONTyped,
    TokenSwapNativeInputToJSON,
} from './TokenSwapNativeInput';
import type { TokenTransfer } from './TokenTransfer';
import {
    TokenTransferFromJSON,
    TokenTransferFromJSONTyped,
    TokenTransferToJSON,
} from './TokenTransfer';

/**
 * 
 * @export
 * @interface TokenSwap
 */
export interface TokenSwap {
    /**
     * 
     * @type {TokenSwapNativeInput}
     * @memberof TokenSwap
     */
    nativeInput: TokenSwapNativeInput | null;
    /**
     * 
     * @type {TokenSwapNativeInput}
     * @memberof TokenSwap
     */
    nativeOutput: TokenSwapNativeInput | null;
    /**
     * 
     * @type {Array<TokenTransfer>}
     * @memberof TokenSwap
     */
    tokenInputs: Array<TokenTransfer>;
    /**
     * 
     * @type {Array<TokenTransfer>}
     * @memberof TokenSwap
     */
    tokenOutputs: Array<TokenTransfer>;
    /**
     * 
     * @type {Array<TokenTransfer>}
     * @memberof TokenSwap
     */
    tokenFees: Array<TokenTransfer>;
    /**
     * 
     * @type {Array<NativeTransfer>}
     * @memberof TokenSwap
     */
    nativeFees: Array<NativeTransfer>;
    /**
     * 
     * @type {ProgramInfo}
     * @memberof TokenSwap
     */
    programInfo: ProgramInfo;
}

/**
 * Check if a given object implements the TokenSwap interface.
 */
export function instanceOfTokenSwap(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "nativeInput" in value;
    isInstance = isInstance && "nativeOutput" in value;
    isInstance = isInstance && "tokenInputs" in value;
    isInstance = isInstance && "tokenOutputs" in value;
    isInstance = isInstance && "tokenFees" in value;
    isInstance = isInstance && "nativeFees" in value;
    isInstance = isInstance && "programInfo" in value;

    return isInstance;
}

export function TokenSwapFromJSON(json: any): TokenSwap {
    return TokenSwapFromJSONTyped(json, false);
}

export function TokenSwapFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenSwap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nativeInput': TokenSwapNativeInputFromJSON(json['nativeInput']),
        'nativeOutput': TokenSwapNativeInputFromJSON(json['nativeOutput']),
        'tokenInputs': ((json['tokenInputs'] as Array<any>).map(TokenTransferFromJSON)),
        'tokenOutputs': ((json['tokenOutputs'] as Array<any>).map(TokenTransferFromJSON)),
        'tokenFees': ((json['tokenFees'] as Array<any>).map(TokenTransferFromJSON)),
        'nativeFees': ((json['nativeFees'] as Array<any>).map(NativeTransferFromJSON)),
        'programInfo': ProgramInfoFromJSON(json['programInfo']),
    };
}

export function TokenSwapToJSON(value?: TokenSwap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nativeInput': TokenSwapNativeInputToJSON(value.nativeInput),
        'nativeOutput': TokenSwapNativeInputToJSON(value.nativeOutput),
        'tokenInputs': ((value.tokenInputs as Array<any>).map(TokenTransferToJSON)),
        'tokenOutputs': ((value.tokenOutputs as Array<any>).map(TokenTransferToJSON)),
        'tokenFees': ((value.tokenFees as Array<any>).map(TokenTransferToJSON)),
        'nativeFees': ((value.nativeFees as Array<any>).map(NativeTransferToJSON)),
        'programInfo': ProgramInfoToJSON(value.programInfo),
    };
}

